module.exports = __webpack_public_path__ + "static/media/Frame_66a4.3dc2acff.png";